"use strict";

exports.__esModule = true;
exports.SYMBOL_TRIANGLE = exports.SYMBOL_ROUND_RECT = exports.SYMBOL_RECT = exports.SYMBOL_PIN = exports.SYMBOL_NONE = exports.SYMBOL_DIAMOND = exports.SYMBOL_CIRCLE = exports.SYMBOL_ARROW = exports.ORIENTATION_VERTICAL = exports.ORIENTATION_HORIZONTAL = exports.LAYOUT_TWO_ROWS = exports.LAYOUT_TWO_COLUMNS = exports.LAYOUT_TOP_ROW_TWO_TILES = exports.LAYOUT_THREE_ROWS = exports.LAYOUT_THREE_COLUMNS = exports.LAYOUT_RIGHT_COLUMN_TWO_TILES = exports.LAYOUT_LEFT_COLUMN_TWO_TILES = exports.LAYOUT_BOTTOM_ROW_TWO_TILES = exports.CHART_STACK = exports.CHART_SCATTER = exports.CHART_PIE = exports.CHART_LINE = exports.CHART_BAR = exports.AXIS_VALUE = exports.AXIS_TIME = exports.AXIS_CATEGORY = exports.AGGR_SUM = exports.AGGR_MIN = exports.AGGR_MAX = exports.AGGR_AVG = void 0;
var CHART_LINE = exports.CHART_LINE = "line";
var CHART_BAR = exports.CHART_BAR = "bar";
var CHART_SCATTER = exports.CHART_SCATTER = "scatter";
var CHART_PIE = exports.CHART_PIE = "pie";
var CHART_STACK = exports.CHART_STACK = "stack";
var LAYOUT_TWO_COLUMNS = exports.LAYOUT_TWO_COLUMNS = "twoColumns";
var LAYOUT_TWO_ROWS = exports.LAYOUT_TWO_ROWS = "twoRows";
var LAYOUT_THREE_COLUMNS = exports.LAYOUT_THREE_COLUMNS = "threeColumns";
var LAYOUT_THREE_ROWS = exports.LAYOUT_THREE_ROWS = "threeRows";
var LAYOUT_BOTTOM_ROW_TWO_TILES = exports.LAYOUT_BOTTOM_ROW_TWO_TILES = "bottomRowTwoTiles";
var LAYOUT_LEFT_COLUMN_TWO_TILES = exports.LAYOUT_LEFT_COLUMN_TWO_TILES = "leftColumnTwoTiles";
var LAYOUT_TOP_ROW_TWO_TILES = exports.LAYOUT_TOP_ROW_TWO_TILES = "topRowTwoTiles";
var LAYOUT_RIGHT_COLUMN_TWO_TILES = exports.LAYOUT_RIGHT_COLUMN_TWO_TILES = "rightColumnTwoTiles";
var AGGR_SUM = exports.AGGR_SUM = "sum";
var AGGR_AVG = exports.AGGR_AVG = "average";
var AGGR_MIN = exports.AGGR_MIN = "min";
var AGGR_MAX = exports.AGGR_MAX = "max";
var AXIS_TIME = exports.AXIS_TIME = "time";
var AXIS_VALUE = exports.AXIS_VALUE = "value";
var AXIS_CATEGORY = exports.AXIS_CATEGORY = "category";
var SYMBOL_CIRCLE = exports.SYMBOL_CIRCLE = "circle";
var SYMBOL_RECT = exports.SYMBOL_RECT = "rect";
var SYMBOL_ROUND_RECT = exports.SYMBOL_ROUND_RECT = "roundRect";
var SYMBOL_TRIANGLE = exports.SYMBOL_TRIANGLE = "triangle";
var SYMBOL_DIAMOND = exports.SYMBOL_DIAMOND = "diamond";
var SYMBOL_PIN = exports.SYMBOL_PIN = "pin";
var SYMBOL_ARROW = exports.SYMBOL_ARROW = "arrow";
var SYMBOL_NONE = exports.SYMBOL_NONE = "none";
var ORIENTATION_VERTICAL = exports.ORIENTATION_VERTICAL = "vertical";
var ORIENTATION_HORIZONTAL = exports.ORIENTATION_HORIZONTAL = "horizontal";